// extracted by mini-css-extract-plugin
export default {"shop-replacement-button-container":"shop-replacement-button__shop-replacement-button-container___3Ds-Q","shop-button":"shop-replacement-button__shop-button___1JGRk"};